import { useEffect } from "react";

export function useBrandTitle(brand) {
  useEffect(() => {
    if (!brand?.name) return;
    const prev = document.title;
    document.title = brand.name;
    let icon = null;
    if (brand.logo_url) {
      icon = document.createElement("link");
      icon.rel = "icon";
      icon.href = brand.logo_url;
      document.head.appendChild(icon);
    }
    return () => { document.title = prev; icon?.remove(); };
  }, [brand?.name, brand?.logo_url]);
}
